// @flow
import { combineReducers } from 'redux';
import { authReducer } from './auth';
import { podReducer } from './pod';
import { skuReducer } from './sku';
import { cartReducer } from './cart';
import { snackbarReducer } from './snackbar';
import { userReducer } from './user';
import { paymentReducer } from './payment';
import { orderReducer } from './orders';
import { passbookReducer } from './passbook';
import { feedbackReducer } from './feedback';
import { serviceWorkerReducer } from './serviceWorker';
import { walletReducer } from './wallet';
import { vShelfReducer } from './virtual-shelf';
import { ratingReducer } from './rating';
import { tipsReducer } from './tips';
import { deliveryReducer } from './delivery';
import { appReducer } from './app';

export default combineReducers({
	auth: authReducer,
	pod: podReducer,
	sku: skuReducer,
	cart: cartReducer,
	snackbar: snackbarReducer,
	user: userReducer,
	payment: paymentReducer,
	orders: orderReducer,
	passbook: passbookReducer,
	feedback: feedbackReducer,
	serviceWorker: serviceWorkerReducer,
	wallet: walletReducer,
	virtualShelf: vShelfReducer,
	rating: ratingReducer,
	tips: tipsReducer,
	delivery: deliveryReducer,
	app: appReducer,
});
